import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Modal from '../Common/Modal/Modal';
import styles from '../AccountHeader/AccountHeader.module.css';
import MenuCustomer from '../../screens/User/Menu/MenuCustomer';
import NotificationsInactiveIcon from '../icons/Menu/NotificationsInactiveIcon';
import UserIcon from '../icons/userIcon';

const AccountHeaderConsumer = ({ title }) => {
  const history = useHistory();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const user = useSelector((state) => state.associates.user);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeModal = (modalSetter) => () => {
    modalSetter(false);
  };

  return (
    <>
      <div className={`${styles.headerUser} ${styles.container} header app position-fixed w-100`}>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-12 col-md-7 col-lg-6'>
              <div className={`row ${styles.headerContent}`}>
                <div className='col-auto my-auto pr-0' onClick={toggleMenu}>
                  <div className={styles.profileContainer}>
                    {user?.profilePic && (
                      <img
                        src={user.profileImage}
                        alt='User Profile'
                        onLoad={() => setIsImageLoaded(true)}
                        style={{ display: isImageLoaded ? 'block' : 'none' }}
                      />
                    )}
                    {!isImageLoaded && <UserIcon size={20} color='#fff' />}
                  </div>
                </div>
                <div className='col text-center my-auto bold'>{title}</div>
                <div
                  className='col-auto my-auto pl-0'
                  onClick={() => history.push('/notifications-customer')}
                >
                  <div className='text-right' style={{ width: '28.8px' }}>
                    <NotificationsInactiveIcon size={20} color={'#fff'} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={isMenuOpen}
        onClose={closeModal(setIsMenuOpen)}
        animationClass='slide-left-right'
        fullScreen={true}
        hasBackground={true}
      >
        <MenuCustomer history={history} />
      </Modal>
    </>
  );
};

export default AccountHeaderConsumer;
